import {ApiResource} from 'common/util/model-resource/api-resource';
import {ProjectMember} from 'common/types/app-api/project-member';

import {projectUsersClient} from '../queries/app-api/project-users-client';

export class ProjectUsersResource extends ApiResource<ProjectMember> {
  apiClient = projectUsersClient;

  getFilteredMembers({emails}: {emails: string[]}): ProjectMember[] {
    const emailSet = new Set(emails);
    return this.getAllValues().filter((member) => emailSet.has(member.email));
  }

  getFilteredEmails({emails}: {emails: string[]}): string[] {
    return this.getFilteredMembers({emails}).map((member) => member.email);
  }
}
